//import store from "@/store";
import { useStore } from "vuex";
//import router from "@/router";
import { useRouter } from "vue-router";

export function useLogout() {
  // Importando o store do Vuex e o router do Vue Router
  const store = useStore();
  const router = useRouter();

  async function logoutUser(){
    try {
      return await store.dispatch("auth/logout").then(() => {
        return router.push({ name: "login" });
      }).finally(()=>{
        // console.clear();
        return router.push({ name: "login" });
      });
    } catch (error) {
      console.log("Erro ao fazer logout:", error);
      // console.clear();
    }
    return await router.push({ name: "login" });
  }

  return {
    logoutUser,
  };
}
